export const output = (price = '', withFixed = false) => {
  if (price.toString().split('')[price.length - 1] === '.') {
    return price;
  }

  if (withFixed) {
    price /= 100;
    return price.toFixed(2);
  }

  return price / 100;
};

export const convertToCents = (dollarAmount) => {
  return Math.round(dollarAmount * 100);
};

export const CurrencyFormatter = (value) => {
  if (typeof value !== 'number') value = parseFloat(value);
  if (Number.isNaN(value)) return '$0.00'; // <-- use Number.isNaN here

  const parts = value.toFixed(2).split('.');
  const integer = parts[0];
  const decimal = parts[1];

  const withCommas = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `$${withCommas}.${decimal}`;
};
